import React from 'react';
import './expandable_div.scss';

class ExpandableDiv extends React.Component {
  constructor(props) {
    super(props);

    this.wrapperElement = null;
    this.wrapperRef = (element) => {
      this.wrapperElement = element;
    };

    this.containerElement = null;
    this.containerRef = (element) => {
      this.containerElement = element;

      if (element && !this.props.visible) {
        this.containerElement.style.setProperty('height', '0');
        this.containerElement.style.setProperty('margin-bottom', '0');
      }
    };

    this.ANIMATION_PERIOD = 420;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible !== this.props.visible) {
      if (this.props.visible) {
        if (this.wrapperElement !== null && this.containerElement !== null) {
          requestAnimationFrame(() => {
            const clientRect = this.wrapperElement.getBoundingClientRect();
            
            this.containerElement.style.setProperty('height', `${clientRect.height}px`);
  
            if (this.props.visibleMarginBottom) {
              this.containerElement.style.setProperty('margin-bottom', this.props.visibleMarginBottom);
            }
  
            setTimeout(() => {
              requestAnimationFrame(() => {
                this.containerElement.style.removeProperty('height');
              });
            }, this.ANIMATION_PERIOD)
          });
        }
      }
      else if (this.wrapperElement !== null && this.containerElement !== null) {
        const clientRect = this.wrapperElement.getBoundingClientRect();
        this.containerElement.style.setProperty('height', `${clientRect.height}px`);
  
        requestAnimationFrame(() => {
          this.containerElement.style.setProperty('height', '0');
          this.containerElement.style.setProperty('margin-bottom', '0');
        });
      }
    }
  }

  render() {
    const wrapperStyle = {};

    if(this.props.background) {
        wrapperStyle.background = this.props.background;
    }

    return (
      <div
        className={`expandable-div${this.props.visible ? '--open' : '--closed'}${this.props.className ? ` ${this.props.className}` : ''}`}
        ref={this.containerRef}
      >

        <div 
          className="expandable-div__wrapper"
          style={wrapperStyle}
          ref={this.wrapperRef}
        >

            {this.props.children}

        </div>

      </div>
    );
  }
}

export default ExpandableDiv;
